import { Component, inject, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from "@angular/router";

import { ComponentBase, DialogService } from "@definitiv-packages/angular-dba-library";
import { CompletedFormDialogComponent, CompletedFormDialogData, FormFieldTypeEnum } from "@definitiv-packages/angular-forms-library";
import { Document, DocumentService } from '@definitiv-packages/angular-documents-library';
import {ProjectLanguage, ObjektViewService,TodoViewService,SafetyPointFormModelViewService,SafetyPointViewService, TodoService,TodoModelView, TodoModel,SafetyPointFormModelView, AppService,ObjektModelView, 
    SafetyPointModelView,  RoofAreaView, 
    RoofareaService,
    SafetyPointFormModel,
    SafetyPointFormModelService,
    RoofareaModelView} from "../../../../../roofsafetymanagement-library/src/public-api";
import { firstValueFrom } from "rxjs";
import { DocumentDataType } from "../../../../../roofsafetymanagement-library/src/public-api";
import { HttpClient } from "@angular/common/http";
import { GoogleMap } from "@angular/google-maps";
@Component({
    selector: 'app-todos-view',
    templateUrl: './todos-view.component.html',
    styleUrls: ['./todos-view.component.scss'],
    standalone: false
})
export class TodosViewComponent extends ComponentBase<ProjectLanguage> implements OnInit {

    public TodosList: TodoModelView[] = [];
    public SafetypointFormList: SafetyPointFormModelView[]=[];
    public documentList: Document[] = [];
    public safetyPointList: SafetyPointModelView[] = [];
    public roofAreaList: RoofAreaView[] = [];
    public objektList: ObjektModelView[] = [];
    public FilterListe: filterOption[] = [];      
    private roofIconBase64 : string = "";
    private safetyiconBase64 : string = "";
    private _http = inject(HttpClient);
    public selectedFilter: filterOption = new filterOption();

@ViewChild(GoogleMap) public map: GoogleMap | null = null;    
    public center : google.maps.LatLngLiteral = {
        lat: 51.97658,
        lng: 7.59885,
    };

    ngAfterViewInit() {
        this.waitForGoogleMaps();
    }
mapOptions: google.maps.MapOptions = {
  styles: [
    {
      featureType: "poi",
      elementType: "labels.icon",
      stylers: [{ visibility: "off" }]
    }
  ]
};
    markers : MapMarkerData[] = [];

  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    animation: null,
  };    
    constructor(
        private todoViewService: TodoViewService,
        private TodoService: TodoService,
            private safetyPointFormModelService: SafetyPointFormModelService,
        public dialogService: DialogService,
        private safetyPointService: SafetyPointViewService,
        private dialog: MatDialog,
        private documentService: DocumentService,
        private route: ActivatedRoute,
        private roofAreaService:RoofareaService,
        private appService: AppService,
        private safetyPointFormModelViewService: SafetyPointFormModelViewService,
        private objektViewService: ObjektViewService,
        private router: Router
    ) {
        super();
    }

    showDetails(
        dialogTemplate: TemplateRef<any>,
        tableTemplate: TemplateRef<any>,
        title: string | null = null
    ) {    
        this.dialog.open(dialogTemplate, {
        maxWidth: '90vw',
        maxHeight: '80vh',
        data: { title: title, content: tableTemplate },
        });
    }

    ngOnInit() {
        

    this._http.get('assets/images/safetypoint_icon.png', { responseType: 'blob' }).subscribe((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
          this.safetyiconBase64 = reader.result as string;
        };
      });

    this._http.get('assets/images/roof.png', { responseType: 'blob' }).subscribe((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => {
          this.roofIconBase64 = reader.result as string;
        };
      });          
      
    }

    public async loadData() {
        this.loading = true;
        var resultList = await Promise.all([
            this.todoViewService.getList(),   
            this.safetyPointFormModelViewService.getList(),
            this.safetyPointService.getList(),
            this.objektViewService.getList(),
            this.roofAreaService.getList(),
            this.documentService.getList()
        ])
        
        this.TodosList = resultList[0].sort((a,b)=>{
            return (a.Termin<b.Termin)?-1:1
        })
          
        this.objektList = resultList[3];
        const objIDs = this.objektList.filter(x=>x.SafetyPointCount == 0).map(y=>y.ObjektID);        
        this.TodosList = this.TodosList.filter(x=>!objIDs.includes(x.ObjektId));
        this.SafetypointFormList = resultList[1];
        this.safetyPointList = resultList[2];
        this.documentList = resultList[5]

        this.roofAreaList = resultList[4].map(roofArea => new RoofAreaView(roofArea, resultList[2].filter(safetyPoint => safetyPoint.RoofareaId == roofArea.RoofareaID)));

        this.setMarkers()
        this.loading = false;
    }

    public navigateToObjectService(toDo: TodoModelView): void {
        this.router.navigate(['/object-service/', toDo.ObjektId],{ queryParams: { todoId: toDo.TodoId }} );
    }

    public todoErledigen(todo: TodoModelView) {
        var dat = new CompletedFormDialogData(todo.FormId);

        this.dialog.open(CompletedFormDialogComponent, { data: dat }).afterClosed().subscribe(res => {
            if (res) {

                todo.CompletedFormId = 1;
                todo.ErledigtVonId = this.appService.CurrentUser?.UserID!
                todo.ErledigtAm = new Date();
                todo.Bemerkung = null;
                this.TodoService.put(todo.TodoId, todo as TodoModel)
            }
        })
    }
    public todoStornieren(todo: TodoModelView) {
        this.dialogService.showInputDialog(this.languageService.getText(this.language.TodoStornieren), '', this.languageService.getText(this.language.BitteBegruendungEigeben)).subscribe(res => {
            if (res) {

                todo.CompletedFormId = 1;
                todo.ErledigtVonId = this.appService.CurrentUser?.UserID!
                todo.ErledigtAm = new Date();
                todo.Bemerkung = res;              
                this.TodoService.put(todo.TodoId, todo as TodoModel)
       
            }
        })
    }

    public filteredTodos() {
        if (this.selectedFilter.ID == "1") {
            return this.TodosList.filter(x => x.ErledigtAm != null && x.Bemerkung == null);
        }

        if (this.selectedFilter.ID == "2") {
            return this.TodosList.filter(x => x.ErledigtAm != null && x.Bemerkung == null);
        }
        return this.TodosList;
    }

  getObjektistErledigt(todo: TodoModelView):boolean{
       
      if(!todo) return false;
      var object = this.objektList.find(x=>x.ObjektID == todo.ObjektId);
      if(!object) return false;
      return this.SafetypointFormList.filter(x=>x.ObjektID == object!.ObjektID && x.TodoId == todo.TodoId).length == this.safetyPointList.filter(x=>x.ObjektID==object!.ObjektID).length &&
      this.safetyPointList.filter(x=>x.ObjektID==object!.ObjektID).length>0;
  }    

    public async openSafetyPointServiceDialog(safetyPoint: SafetyPointModelView, todo: TodoModelView): Promise<void> {
        if (!safetyPoint.FormId) return;
        
        this.SafetypointFormList = await  this.safetyPointFormModelViewService.getFilteredList({ ObjektID: safetyPoint.ObjektID})
        var safetyPointFormList  = this.SafetypointFormList.filter(x=> x.TodoId== todo.TodoId &&  x.SafetyPointId == safetyPoint.SafetyPointId);    
        var _data = (safetyPointFormList.length>0)? new  CompletedFormDialogData(safetyPoint.FormId, safetyPointFormList[0].CompletedFormId):new CompletedFormDialogData(safetyPoint.FormId);
        var res = await firstValueFrom(this.dialog.open(CompletedFormDialogComponent, { data: _data }).afterClosed());
            if (res) {        
                safetyPoint.Erledigt = true;
                var safetypointForm = new SafetyPointFormModel();
                    safetypointForm.CompletedFormId = res.CompletedFormId;
                    safetypointForm.TodoId = todo.TodoId!;
                    safetypointForm.SafetyPointId = safetyPoint.SafetyPointId;
                    safetypointForm.Datum = new Date();            
                var res1 = await this.safetyPointFormModelService.post(safetypointForm);
                await this.todoViewService.getCountTodos();
                this.SafetypointFormList = await this.safetyPointFormModelViewService.getFilteredList({ ObjektID: safetyPoint.ObjektID});
            }
    }  

    getRoofareayistErledigt(object: RoofAreaView|null=null, todo: TodoModelView):boolean{
        
        if(!object || !todo) return false;      
        return this.SafetypointFormList.filter(x=>x.RoofareaID == object.roofArea.RoofareaID && x.TodoId == todo.TodoId).length ==  object.safetyPointList.length && object.safetyPointList.length>0;
    }     

    getSafetypointistErledigt(object: SafetyPointModelView|null=null, todo: TodoModelView):boolean{
        
        if(!object || !todo) return false;      
        return this.SafetypointFormList.filter(x=>x.SafetyPointId == object.SafetyPointId && x.TodoId == todo.TodoId).length>0;
    }       

    getDokumentList(safetyPoint: SafetyPointModelView){

        return this.documentList.filter(x=>x.DataTypeID == DocumentDataType.SafetyPoint && x.DataID == safetyPoint.SafetyPointId)
    }

    objektCLicked(objektId: number){

        this.markers = [];    
        this.roofAreaList.filter(x=>x.roofArea.ObjektID == objektId).forEach(elem=>{        
            this.markers.push(this.toRoofareaMapData(elem));
            elem.safetyPointList.forEach(element=>{
                this.markers.push(this.toSafetypointMapData(element));
            })
            this.center ={
                lat: elem.roofArea.Latitude!,
                lng: elem.roofArea.Longitude!,
            } 
        })
    }
  
    safetypointCLicked(safetyPoint: SafetyPointModelView){
        this.markers = [];
        this.markers.push(this.toSafetypointMapData(safetyPoint))
        this.center ={
            lat: safetyPoint.Latitude!,
            lng: safetyPoint.Longitude!,
        } 
    }
    setMarkers(){
        if(!this.map)return;
        const distinct = this.TodosList.filter(
        (user, index, self) =>
            index === self.findIndex(u => u.ObjektId === user.ObjektId)
        );        
        distinct.forEach(todo => {
        this.roofAreaList.filter(x=>x.roofArea.ObjektID == todo.ObjektId).forEach(elem=>{        
            this.markers.push(this.toRoofareaMapData(elem));
            elem.safetyPointList.forEach(element=>{
                this.markers.push(this.toSafetypointMapData(element));
            })
            this.center ={
                lat: elem.roofArea.Latitude!,
                lng: elem.roofArea.Longitude!,
            } 
        })            
        });
    }

    toRoofareaMapData(roofarea: RoofAreaView){
            
            const labelColor = 'white';
            var iconContent = `
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                <image href="${this.roofIconBase64}" x="2" y="2" width="32" height="32" />
                <text x="18" y="22" font-size="14" text-anchor="middle" fill="${labelColor}">${roofarea.roofArea.Bezeichnung}</text>
            </svg>
            `;        
            const markerIcon: google.maps.Icon = {
                url:'data:image/svg+xml;charset=utf-8,' +encodeURIComponent(iconContent),scaledSize: new google.maps.Size(36, 36),size: new google.maps.Size(36, 36)
            };    
        const marker: MapMarkerData = {
                
            title: this.languageService.getText(this.language.roofarea)+": "+ roofarea.roofArea.Bezeichnung,
            data:{
                istRoofArea: true,
                Bezeichnung: roofarea.roofArea.Bezeichnung,
                istSafetypoint: false,
                Kunde: this.objektList.find(x=>x.ObjektID == roofarea.roofArea.ObjektID)?. DebitorName!,
                ID: roofarea.roofArea.RoofareaID,
                Latitude: roofarea.roofArea.Latitude,
                Longitude: roofarea.roofArea.Longitude,
                Objekt: this.objektList.find(x=>x.ObjektID ==  roofarea.roofArea.ObjektID)?.Bezeichnung!,
                AnzahlSafetypoints: roofarea.safetyPointList.length,
                Roofarea:roofarea.roofArea.Bezeichnung                
            },
            position: {
            lat: roofarea.roofArea.Latitude!,
            lng: roofarea.roofArea.Longitude!,
            },
            icon: markerIcon,
            normalIcon: markerIcon,
            hoverIcon: "",
            markerOptions: this.markerOptions,
        };  
        return marker
    }

    
    toSafetypointMapData(safetypoint: SafetyPointModelView){
        
            const labelColor = 'white';
            var iconContent = `
            <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
                <image href="${this.safetyiconBase64}" x="2" y="2" width="32" height="32" />
                <text x="18" y="22" font-size="14" text-anchor="middle" fill="${labelColor}">${safetypoint.Bezeichnung}</text>
            </svg>
            `;        
            const markerIcon: google.maps.Icon = {
                url:'data:image/svg+xml;charset=utf-8,' +encodeURIComponent(iconContent),scaledSize: new google.maps.Size(36, 36),size: new google.maps.Size(36, 36)
            };    
        const marker: MapMarkerData = {
            
    
            title: this.languageService.getText(this.language.safetypoint)+": "+ safetypoint.Bezeichnung,
            data:{
                istRoofArea: false,
                istSafetypoint: true,
                Kunde : safetypoint.Debitorname!,
                ID: safetypoint.SafetyPointId,
                Bezeichnung: safetypoint.Bezeichnung,
                Latitude: safetypoint.Latitude,
                Longitude: safetypoint.Longitude,
                Objekt: safetypoint.ObjektBezeichnung!,
                AnzahlSafetypoints: 0,
                Roofarea:safetypoint.RoofareaBezeichnung!
            },   
            position: {             
            lat: safetypoint.Latitude!,
            lng: safetypoint.Longitude!,
            },
            icon: markerIcon,
            normalIcon: markerIcon,
            hoverIcon: "",
            markerOptions: this.markerOptions,
        };  
        return marker
    }

    mapClicked(ev: any){
        
    }

    private waitForGoogleMaps() {
    const interval = setInterval(() => {
        if (
        window.google &&
        google.maps &&
        google.maps.Size
        ) {
        clearInterval(interval);
        this.loadData();
        }
    }, 100);
    }    

}

export class filterOption {
    public ID: string = "";
    public Label: string = "";
}


export class MapData{

}

export interface MapMarkerData{

  hoverIcon: string | google.maps.Icon;
  icon: string | google.maps.Icon;
  markerOptions: google.maps.MarkerOptions;
  normalIcon: string | google.maps.Icon;
  position: google.maps.LatLngLiteral;
  title: string;
  data: markerData

  // #endregion Properties
}

export interface markerData{
    istSafetypoint: boolean,
    istRoofArea: boolean,
    ID: number|null,
    AnzahlSafetypoints: number|null,
    Latitude: number|null,
    Longitude: number|null,
    Objekt: string |null,
    Bezeichnung: string |null,
    Roofarea: string |null,
    Kunde: string |null
}